import { createRoute } from '@tanstack/react-router';
import { labParentRoute } from 'pages/lab/labParentRoute';
import { zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

// Warning: We will have to change the path below to /lab/claims/:id, but preserving the redirection for old secured links
export const labClaimRoute = createRoute({
  getParentRoute: () => labParentRoute,
  path: '/claims/list/$id',
  params: z.object({ id: zodPathParamId }),
}).lazy(() => import('pages/lab/Claims/LabClaimPage/LabClaimPage').then((d) => d.Route));
